const UploadMoreModal = () => (
    <p>
        Haben Sie alle Dateien bzw. Seiten (einschließlich der Rückseiten) des Behördenschreibens ausgewählt?
    </p>
)

export default UploadMoreModal